module.exports = __webpack_public_path__ + "img/荣誉证书03_第六届互联网大赛全国铜奖.8244b3ba.png";